export function assistantStorageKey(schema: { slug?: string; id?: number }, userId: string | number) {
    return `ai-assistant-user-${userId || 'guest'}-${schema?.slug || schema?.id || 'unknown'}`
}

export function clearAssistantCache(storage: Storage) {
    for (let index = storage.length - 1; index >= 0; index--) {
        const key = storage.key(index)
        if (key?.startsWith('ai-assistant-') && key !== 'ai-assistant-panel-width') storage.removeItem(key)
    }
}

export function conversationMessages(conversation: any, apiUrl: string) {
    const attachments = (conversation.attachments || []).map((file: any) => {
        const name = String(file.name).replace(/([\\[\]])/g, '\\$1')
        return `[${name}](${new URL(file.url, apiUrl).href})`
    })
    const messages: any[] = [{
        role: 'user', request_id: conversation.request_id,
        content: [conversation.question, ...attachments].filter(Boolean).join('\n\n')
    }]
    const content = conversation.answer || conversation.error || (conversation.status === 'cancelled' ? 'Request stopped.' : '')
    if (content || conversation.operations?.length) messages.push({
        role: 'assistant', request_id: conversation.request_id,
        content: content || 'Review the proposed changes.',
        operations: conversation.operations || [], applied: conversation.applied || null,
        restoreVersionId: conversation.restore_version_id || null,
        variant: conversation.status === 'failed' ? 'error' : null,
        status: conversation.status, requiresRefresh: !!conversation.requires_refresh, previewOpen: false, dismissed: !!conversation.dismissed
    })
    return messages
}
